




























































































































































































































































































































































































































































































































































































































































































































































































import { SettingApi } from "../api/SettingApi";
import TextInput from "../core/Forms/TextInput.vue";
import { Setting } from "../models/Setting";
import InputField from "../core/Forms/InputField.vue";
import ColorSelector from "./AppSettingsPartials/ColorSelector.vue";
import LogoUploader from "./AppSettingsPartials/LogoUploader.vue";
import HtmlTextareaInput from "../core/Forms/HtmlTextareaInput.vue";
import moment from "moment";
import TextSettingChecker from "./AppSettingsPartials/TextSettingChecker.vue";
import CheckboxInput from "../core/Forms/CheckboxInput.vue";
import NumeralInput from "../core/Forms/NumeraInput.vue";
import { HolidaysApi } from "../api/HolidaysApi";
import OptionSelect from "../core/Forms/OptionSelect.vue";
import { Option } from "../models/Option";
import { Employe } from "../models/Employe";
import TextareaInput from "../core/Forms/TextareaInput.vue";
import RelanceTemplatesFieldset from "./AppSettingsPartials/RelanceTemplatesFieldset.vue";

export default {
    name: "AppSettings",
    components: {
        RelanceTemplatesFieldset,
        TextareaInput,
        OptionSelect,
        NumeralInput,
        CheckboxInput,
        TextSettingChecker,
        HtmlTextareaInput,
        LogoUploader,
        ColorSelector,
        InputField,
        TextInput,
    },
    data() {
        return {
            SettingApi: new SettingApi(),
            HolidaysApi: new HolidaysApi(),
            holidaysList: {},
            Employe: Employe,
            settingsKeys: [
                "app_name",
                "company_name",
                "company_city",
                "company_footer",
                "company_signatory",
                "default_theme",
                "mail_default_reply_address",
                "mail_default_domain",
                "mail_default_sender",
                "mail_default_sender_name",
                "mail_relance_default_bcc",
                "mail_show_logo_in_signature",
                "mail_template",
                "mail_bon_de_passage_template",
                "mail_signalement_template",
                "mail_absence_notif_template",
                "mail_conges_notif_template",
                "mail_demande_double_subject",
                "mail_demande_double_template",
                "cles_pret_alerte_jours",
                "taux_frais_km",
                "geoloc_max_distance",
                "journee_de_solidarite",
                "import_excel_bulletin_salaire_first_row",
                "import_excel_bulletin_salaire_employe_column",
                "import_excel_bulletin_salaire_brut_column",
                "import_excel_bulletin_salaire_cout_column",
                "import_excel_bulletin_de_salaire_ignore_row",
                "import_excel_relance_num_facture_column",
                "import_excel_relance_copropriete_column",
                "import_excel_relance_syndic_column",
                "import_excel_relance_solde_column",
                "import_excel_relance_date_echeance_column",
                "import_excel_releve_bancaire_sheet",
                "import_excel_releve_bancaire_first_row",
                "import_excel_releve_bancaire_date_column",
                "import_excel_releve_bancaire_libelle_column",
                "import_excel_releve_bancaire_debit_column",
                "import_excel_releve_bancaire_credit_column",
                "token_cost",
                "bulletin_salaire_max_pages",
                "ai_daily_token_limit",
                "bulletin_salaire_prompt",
            ],
            settings: {
                app_name: <Setting>{ key: "app_name", value: "" },
                company_name: <Setting>{ key: "company_name", value: "" },
                company_city: <Setting>{ key: "company_city", value: "" },
                company_footer: <Setting>{ key: "company_footer", value: "" },
                company_signatory: <Setting>{
                    key: "company_signatory",
                    value: "",
                },
                default_theme: <Setting>{ key: "default_theme", value: "" },
                mail_default_reply_address: <Setting>{
                    key: "mail_default_reply_address",
                    value: "",
                },
                mail_default_sender: <Setting>{
                    key: "mail_default_sender",
                    value: "",
                },
                mail_default_sender_name: <Setting>{
                    key: "mail_default_sender_name",
                    value: "",
                },
                mail_default_domain: <Setting>{
                    key: "mail_default_domain",
                    value: "",
                },
                mail_relance_default_bcc: <Setting>{
                    key: "mail_relance_default_bcc",
                    value: "",
                },
                mail_show_logo_in_signature: <Setting>{
                    key: "mail_show_logo_in_signature",
                    value: "",
                },
                mail_template: <Setting>{ key: "mail_template", value: "" },
                mail_bon_de_passage_template: <Setting>{
                    key: "mail_bon_de_passage_template",
                    value: "",
                },
                mail_signalement_template: <Setting>{
                    key: "mail_signalement_template",
                    value: "",
                },
                mail_absence_notif_template: <Setting>{
                    key: "mail_absence_notif_template",
                    value: "",
                },
                mail_conges_notif_template: <Setting>{
                    key: "mail_conges_notif_template",
                    value: "",
                },
                mail_demande_double_subject: <Setting>{
                    key: "mail_demande_double_subject",
                    value: "",
                },
                mail_demande_double_template: <Setting>{
                    key: "mail_demande_double_template",
                    value: "",
                },
                cles_pret_alerte_jours: <Setting>{
                    key: "cles_pret_alerte_jours",
                    value: 0,
                },
                taux_frais_km: <Setting>{ key: "taux_frais_km", value: 0 },
                geoloc_max_distance: <Setting>{
                    key: "geoloc_max_distance",
                    value: 0,
                },
                journee_de_solidarite: <Setting>{
                    key: "journee_de_solidarite",
                    value: "",
                },
                import_excel_bulletin_salaire_first_row: <Setting>{
                    key: "import_excel_bulletin_salaire_first_row",
                    value: "",
                },
                import_excel_bulletin_salaire_employe_column: <Setting>{
                    key: "import_excel_bulletin_salaire_employe_column",
                    value: "",
                },
                import_excel_bulletin_salaire_brut_column: <Setting>{
                    key: "import_excel_bulletin_salaire_brut_column",
                    value: "",
                },
                import_excel_bulletin_salaire_cout_column: <Setting>{
                    key: "import_excel_bulletin_salaire_cout_column",
                    value: "",
                },
                import_excel_bulletin_de_salaire_ignore_row: <Setting>{
                    key: "import_excel_bulletin_de_salaire_ignore_row",
                    value: "",
                },
                import_excel_relance_num_facture_column: <Setting>{
                    key: "import_excel_relance_num_facture_column",
                    value: "",
                },
                import_excel_relance_copropriete_column: <Setting>{
                    key: "import_excel_relance_copropriete_column",
                    value: "",
                },
                import_excel_relance_syndic_column: <Setting>{
                    key: "import_excel_relance_syndic_column",
                    value: "",
                },
                import_excel_relance_solde_column: <Setting>{
                    key: "import_excel_relance_solde_column",
                    value: "",
                },
                import_excel_relance_date_echeance_column: <Setting>{
                    key: "import_excel_relance_date_echeance_column",
                    value: "",
                },
                import_excel_releve_bancaire_sheet: <Setting>{
                    key: "import_excel_releve_bancaire_sheet",
                    value: "",
                },
                import_excel_releve_bancaire_first_row: <Setting>{
                    key: "import_excel_releve_bancaire_first_row",
                    value: "",
                },
                import_excel_releve_bancaire_date_column: <Setting>{
                    key: "import_excel_releve_bancaire_date_column",
                    value: "",
                },
                import_excel_releve_bancaire_libelle_column: <Setting>{
                    key: "import_excel_releve_bancaire_libelle_column",
                    value: "",
                },
                import_excel_releve_bancaire_debit_column: <Setting>{
                    key: "import_excel_releve_bancaire_debit_column",
                    value: "",
                },
                import_excel_releve_bancaire_credit_column: <Setting>{
                    key: "import_excel_releve_bancaire_credit_column",
                    value: "",
                },
                token_cost: <Setting>{ key: "token_cost", value: 0 },
                bulletin_salaire_max_pages: <Setting>{
                    key: "bulletin_salaire_max_pages",
                    value: 0,
                },
                ai_daily_token_limit: <Setting>{
                    key: "ai_daily_token_limit",
                    value: 0,
                },
                bulletin_salaire_prompt: <Setting>{
                    key: "bulletin_salaire_prompt",
                    value: "",
                },
            },
        };
    },
    computed: {
        fullDateExample() {
            return moment().format("Do MMMM YYYY");
        },
        shortDateExample() {
            return moment().format("Do MMMM YYYY");
        },
    },
    created() {
        this.getAllSettings();
        this.getHolidaysList();
    },
    methods: {
        getSetting(key: string) {
            let self = this;
            return self.SettingApi.get(key).then(function (res) {
                self.settings[key] = res;
            });
        },
        saveSetting(setting: Setting) {
            let self = this;
            return self.SettingApi.set(setting).then(function (res) {
                self.settings[setting.key] = res;
            });
        },
        getAllSettings() {
            let self = this;
            _.each(this.settingsKeys, function (key) {
                self.getSetting(key);
            });
        },
        saveAllSettings() {
            let self = this;
            let promises = [];
            _.each(this.settingsKeys, function (key) {
                if (key == "mail_default_domain") return;
                let setting = self.settings[key];
                if (setting) {
                    promises.push(self.saveSetting(setting));
                }
            });

            // Les modèles de relance ne sont pas des settings « à plat » : le
            // partiel gère son propre enregistrement, branché sur le même
            // bouton pour éviter deux façons d'enregistrer la page.
            if (self.$refs.relanceTemplates) {
                promises = promises.concat(
                    self.$refs.relanceTemplates.saveAll()
                );
            }
            Promise.all(promises).then(function () {
                swal(
                    "Paramètres enregistrés avec succès !",
                    "Ils seront pris en compte après le rechargement de l'application.",
                    "success"
                ).then(function () {
                    localStorage.setItem("nocloseconfirmation", "true");
                    location.reload();
                });
            });
        },
        // Holidays
        getHolidaysList() {
            let self = this;
            self.HolidaysApi.getListAsOptions().then(function (res) {
                res.unshift(<Option>{
                    id: "none",
                    name: "Non définie",
                });
                self.holidaysList = _.keyBy(res, "id");
            });
        },
    },
};
